module.exports = __webpack_public_path__ + "static/media/warning.bc411bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/share/warning.svg
// module id = 508
// module chunks = 4